import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getAllBlog,
  createBlog,
  updateBlog,
  getBlogByID,
  deleteBlog,
  ActiveInactiveBlog,
  BlogImageUpload,
} from "./blog.service";
import { IBlog, IBlogState } from "./blogModel";

const initialState: IBlogState = {
  loading: false,
  formLoading: false,
  error: "",
  BlogList: [],
  BlogID: null,
  BlogDetail: {
    ID: null,
    Title: "",
    BlogURL: "",
    BlogDate: "",
    Keyword: "",
    Description: "",
    ShortDescription: "",
    MetaTitle: "",
    MetaDescription: "",
    Image: "",
    BlogBannerImage: "",
    IsActive: true,
  },
  isDeleteModalOpen: false,
  DeleteBlogID: null,
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    setBlogID: (state, action: PayloadAction<number | null>) => {
      state.BlogID = action.payload;
    },
    clearBlogID: (state) => {
      state.BlogID = initialState.BlogID;
    },
    clearBlogDetails: (state) => {
      state.BlogDetail = initialState.BlogDetail;
    },
    openDeleteModal: (state, action: PayloadAction<number>) => {
      state.DeleteBlogID = action.payload;
      state.isDeleteModalOpen = true;
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.DeleteBlogID = null;
    },
  },
  extraReducers: (builder) => {
    // Get All
    builder.addCase(getAllBlog.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getAllBlog.fulfilled,
      (state, action: PayloadAction<IBlog[]>) => {
        state.loading = false;
        state.BlogList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(getAllBlog.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BlogList = [];
    });

    // Create
    builder.addCase(createBlog.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createBlog.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createBlog.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update
    builder.addCase(updateBlog.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateBlog.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateBlog.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get By ID
    builder.addCase(getBlogByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getBlogByID.fulfilled,
      (state, action: PayloadAction<IBlog>) => {
        state.loading = false;
        state.BlogDetail = action.payload;
      },
    );
    builder.addCase(getBlogByID.rejected, (state, action) => {
      state.loading = false;
      state.BlogDetail = initialState.BlogDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete
    builder.addCase(deleteBlog.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteBlog.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBlog.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Active/Inactive
    builder.addCase(ActiveInactiveBlog.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(ActiveInactiveBlog.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveBlog.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Image Upload
    builder.addCase(BlogImageUpload.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(BlogImageUpload.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(BlogImageUpload.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  setBlogID,
  clearBlogDetails,
  clearBlogID,
  openDeleteModal,
  closeDeleteModal,
} = blogSlice.actions;
export default blogSlice.reducer;
